import { type AxiosResponse } from 'axios';

import { UpdatePoolRewardType, type UpdatePoolType } from '@/types';

import { axiosDelete, axiosPatch } from '@/api/AxiosApi';
import { sendRequest } from '@/api/AxiosRequest';
import { type CustomAxiosResponse } from '@/api/AxiosResponse';

export const updatePool = async (
  poolId: string,
  updatePoolType: UpdatePoolType,
): Promise<CustomAxiosResponse | AxiosResponse> => {
  const payload = {
    path: `/staking-setting/${poolId}`,
    body: { ...updatePoolType },
  };
  return sendRequest(payload, 'updatePool', axiosPatch);
};

// 풀 리워드 기간 변경
export const updatePoolReward = async (updatePoolRewardType: UpdatePoolRewardType) => {
  const payload = {
    path: '/staking-setting-reward/update',
    body: { ...updatePoolRewardType },
  };
  return sendRequest(payload, 'updatePoolReward', axiosPatch);
};

// 기존 풀 리워드 삭제
export const deleteReward = async (rewardSetId: string) => {
  const payload = {
    path: `/staking-setting-reward/${rewardSetId}`,
  };
  return sendRequest(payload, 'deleteReward', axiosDelete);
};
